import LocationAttributeBase from '~/client/src/shared/models/LocationObjects/LocationAttributeBase'

import LocationStoreBase from './LocationBase.store'

export default abstract class LocationAttributesStoreBase<
  T extends LocationAttributeBase<T>,
> extends LocationStoreBase<T> {}
